import me from "models/me";
import { getStore } from "store";
import { fetchActiveCompanies, toggleHideMsrp, toggleHideWholesale, fetchLatestTermsSigned } from "actions/scope";
import _ from "lodash";

/**
 * If we want to check should we turn on hide pricing toggles, we must wait for active company to be loaded.
 */
export const checkHidePricing = (scope, store) => {
    const hideMsrp = !!me.getViewPref("hide_product_price_msrp");
    const hideWholesale = !!me.getViewPref("hide_product_price_wholesale");

    if (hideMsrp !== scope.hideMsrp) {
        store.dispatch(toggleHideMsrp(hideMsrp));
    }

    if (hideWholesale !== scope.hideWholesale) {
        store.dispatch(toggleHideWholesale(hideWholesale));
    }
};

export const activeCompany = (nextState, replace, callback) => {
    const store = getStore();
    const { scope, watermarking } = store.getState();
    if (
        me.isSignedIn() &&
        scope.brand &&
        scope.brand._id &&
        me.account_type === "buyer" &&
        (!scope.company || !scope.company._id || scope.brand._id !== scope.company.__brand?.__ref)
    ) {
        const query = {
            __active: true,
            __limit: 100,
            __fields: _.join(
                [
                    "_id,__name,__schema_id,__currency_codes,__settings.__pricing_template,__settings.__default_discount,__settings.__warehouses,__addresses,__brand.__ref,__buyers,access_control,__merchant_id",
                    scope.brand.hasPreference("add_watermarking")
                        ? _.map(watermarking?.payload?.dataAttributes, "key")
                        : [],
                    scope.brand.hasPreference("separate_msrp_currency") ? ["__msrp_currency_codes"] : [],
                ],
                ",",
            ),
        };

        Promise.all([
            store.dispatch(fetchActiveCompanies(query)),
            store.dispatch(fetchLatestTermsSigned(scope.brand._id)),
        ]).then(() => {
            checkHidePricing(scope, store);
            callback();
        });
    } else {
        callback();
    }
};
